import { IUser } from '@Store/types'
import Render from '@Views/components/popin/layout/popin-cancel-subscription.html'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

interface ICancelOptions {
	choice: string
	otherReason: string
}

@Render
@Component
export class PopinCancelSubscription extends Vue {

	@Prop({ required: true }) options!: ICancelOptions
	@Prop({ default: false }) submitted!: boolean

	selectedReason = ''
	otherText = ''

	readonly MAX_LENGTH = 200


	get reasons () {
		return [
			{
				value: 'Changement de modèle économique / abonnement',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.business-change').toString()
			},
			{
				value: 'Trop cher',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.too-expensive').toString() },
			{
				value: 'Manque de fonctionnalités',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.missing-features').toString() },
			{
				value: 'Bugs ou lenteurs',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.bugs-or-slowness').toString() },
			{
				value: 'Je change de logiciel',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.switch-software').toString() },
			{
				value: 'Je n’exerce plus / pause d’activité',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.no-activity').toString() },
			{
				value: 'Problème de confiance ou relation client',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.trust-issues').toString()},
			{
				value: 'other',
				label: this.$t('vm.components.popin.stripe-subscription-cancel.reasons.other').toString()
			}
		]
	}

	get isOtherTooLong(): boolean {
		return this.otherText.length > this.MAX_LENGTH
	}

	get message(): string {
		return this.isOtherTooLong
			? this.$i18n.t('vm.components.popin.stripe-subscription-cancel.maxLength-warning', [this.MAX_LENGTH]).toString()
			: ''
	}

    @Watch('selectedReason')
	onReasonChange(): void {
		this.options.choice = this.selectedReason
	}

	@Watch('otherText')
	onOtherTextChange(): void {
		this.options.otherReason  = this.otherText.slice(0, this.MAX_LENGTH)
	}
}
